export default {
  'userandlogin.login.userName': '賬戶',
  'userandlogin.login.password': '密碼',
  'userandlogin.login.message-invalid-credentials': '賬戶或密碼錯誤（admin/ant.design）',
  'userandlogin.login.message-invalid-verification-code': '驗證碼錯誤',
  'userandlogin.login.tab-login-credentials': '賬戶密碼登錄',
  'userandlogin.login.tab-login-mobile': '手機號登錄',
  'userandlogin.login.remember-me': '自動登錄',
  'userandlogin.login.forgot-password': '忘記密碼',
  'userandlogin.login.sign-in-with': '其他登錄方式',
  'userandlogin.login.signup': '註冊賬戶',
  'userandlogin.login.login': '登錄',
  'userandlogin.register.register': '註冊',
  'userandlogin.register.get-verification-code': '獲取驗證碼',
  'userandlogin.register.sign-in': '使用已有賬戶登錄',
  'userandlogin.register-result.msg': '妳的賬戶：{email} 註冊成功',
  'userandlogin.register-result.activation-email':
    '激活郵件已發送到妳的郵箱中，郵件有效期為24小時。請及時登錄郵箱，點擊郵件中的鏈接激活帳戶。',
  'userandlogin.register-result.back-home': '返回首頁',
  'userandlogin.register-result.view-mailbox': '查看郵箱',
  'userandlogin.email.required': '請輸入郵箱地址！',
  'userandlogin.email.wrong-format': '郵箱地址格式錯誤！',
  'userandlogin.userName.required': '請輸入賬戶!',
  'userandlogin.password.required': '請輸入密碼！',
  'userandlogin.password.twice': '兩次輸入的密碼不匹配!',
  'userandlogin.strength.msg': '請至少輸入 6 個字符。請不要使用容易被猜到的密碼。',
  'userandlogin.strength.strong': '強度：強',
  'userandlogin.strength.medium': '強度：中',
  'userandlogin.strength.short': '強度：太短',
  'userandlogin.confirm-password.required': '請確認密碼！',
  'userandlogin.phone-number.required': '請輸入手機號！',
  'userandlogin.phone-number.wrong-format': '手機號格式錯誤！',
  'userandlogin.verification-code.required': '請輸入驗證碼！',
  'userandlogin.title.required': '請輸入標題',
  'userandlogin.date.required': '請選擇起止日期',
  'userandlogin.goal.required': '請輸入目標描述',
  'userandlogin.standard.required': '請輸入衡量標淮',
  'userandlogin.form.get-captcha': '獲取驗證碼',
  'userandlogin.captcha.second': '秒',
  'userandlogin.form.optional': '（選填）',
  'userandlogin.form.submit': '提交',
  'userandlogin.form.save': '保存',
  'userandlogin.email.placeholder': '郵箱',
  'userandlogin.password.placeholder': '至少6位密碼，區分大小寫',
  'userandlogin.confirm-password.placeholder': '確認密碼',
  'userandlogin.phone-number.placeholder': '手機號',
  'userandlogin.verification-code.placeholder': '驗證碼',
  'userandlogin.title.label': '標題',
  'userandlogin.title.placeholder': '給目標起個名字',
  'userandlogin.date.label': '起止日期',
  'userandlogin.placeholder.start': '開始日期',
  'userandlogin.placeholder.end': '結束日期',
  'userandlogin.goal.label': '目標描述',
  'userandlogin.goal.placeholder': '請輸入妳的階段性工作目標',
  'userandlogin.standard.label': '衡量標淮',
  'userandlogin.standard.placeholder': '請輸入衡量標淮',
  'userandlogin.client.label': '客戶',
  'userandlogin.label.tooltip': '目標的服務對象',
  'userandlogin.client.placeholder': '請描述妳服務的客戶，內部客戶直接 @姓名／工號',
  'userandlogin.invites.label': '邀評人',
  'userandlogin.invites.placeholder': '請直接 @姓名／工號，最多可邀請 5 人',
  'userandlogin.weight.label': '權重',
  'userandlogin.weight.placeholder': '請輸入',
  'userandlogin.public.label': '目標公開',
  'userandlogin.label.help': '客戶、邀評人默認被分享',
  'userandlogin.radio.public': '公開',
  'userandlogin.radio.partially-public': '部分公開',
  'userandlogin.radio.private': '不公開',
  'userandlogin.publicUsers.placeholder': '公開給',
  'userandlogin.option.A': '同事甲',
  'userandlogin.option.B': '同事乙',
  'userandlogin.option.C': '同事丙',
  'userandlogin.navBar.lang': '語言',
};
